import { LatLng } from 'leaflet'

export function coordsToLatLng(coords): LatLng {
  return new LatLng(coords[1], coords[0])
}
